import { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { Schema, ValidationError } from "yup"

export const useYupValidationResolver = <T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validationSchema: Schema<T, any, any, any> | null
) => {
  const { t } = useTranslation()
  return useCallback(
    async (data: T) => {
      if (!validationSchema) {
        return {
          values: data,
          errors: {}
        }
      }

      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
          strict: true
        })

        return {
          values,
          errors: {}
        }
      } catch (errors) {
        return {
          values: {},
          errors: (errors as ValidationError).inner.reduce(
            (allErrors, currentError) => ({
              ...allErrors,
              [currentError.path as string]: {
                type: currentError.type ?? "validation",
                message: currentError.message
              }
            }),
            {}
          )
        }
      }
    },
    [validationSchema, t]
  )
}
